import { render, staticRenderFns } from "./TabelaFechamento.vue?vue&type=template&id=7a4c51f0&"
import script from "./TabelaFechamento.vue?vue&type=script&lang=js&"
export * from "./TabelaFechamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports